import { createFileRoute } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { pageTitle } from "@/components/document-title";
import { ClientsPage } from "@/features/clients/pages/clients-page";
import { clientFilterSchema } from "@/features/clients/schemas/client-filter.schema";

export const Route = createFileRoute("/_authenticated/admin/clients/")({
	head: () => pageTitle("Clients"),
	component: ClientsPage,
	validateSearch: zodValidator(clientFilterSchema),
});
